module.exports = __webpack_public_path__ + "static/media/pic3.da9399cf.jpg";